import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/Layout';
import Toparea from '../components/Toparea';
import { Popup2 } from '../components/Popup';
import Tutorial from '../components/Tutorial';
import '../assets/scss/main.scss'
import '../assets/scss/v1plus.scss'

const Main = (props) => {
	const navigate = useNavigate();
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [attendanceCount, setAttendanceCount] = useState(0);
	const [home, setHome] = useState(null); // { day, streak, due, topic } from /api/learn/home

	useEffect(() => {
		// Check Login Status
		const token = localStorage.getItem('token');
		if (!token) {
			navigate('/');
			return;
		}
		setIsLoggedIn(true);


		// Attendance is recorded when a study/challenge is finished (Finish.js); here we only read it
		axios.get('/api/attendance')
			.then(response => setAttendanceCount(response.data.length))
			.catch(error => console.error('Attendance fetch failed', error));
		axios.get('/api/learn/home')
			.then(response => setHome(response.data))
			.catch(error => console.error('Home fetch failed', error));
	}, [navigate])



	return (
		<Layout containName='main'>
			<Toparea />

			{/* Login/Logout/MyPage Icons */}
			<div className="auth-btn-wrap" style={{
				position: 'absolute',
				top: '20px',
				right: '25px',
				zIndex: 10,
				display: 'flex',
				gap: '18px',
				alignItems: 'center'
			}}>
				{isLoggedIn ? (
					<>
						{/* Logout lives inside the profile page so it can't be tapped by accident here */}
						<Link to="/Profile" title="마이페이지" aria-label="마이페이지" style={{ color: '#171717', display: 'flex', alignItems: 'center' }}>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
								<circle cx="12" cy="7" r="4"></circle>
							</svg>
						</Link>
					</>
				) : (
					<Link to="/Login" title="로그인" style={{ color: '#171717', display: 'flex', alignItems: 'center' }}>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
							<polyline points="10 17 15 12 10 7"></polyline>
							<line x1="15" y1="12" x2="3" y2="12"></line>
						</svg>
					</Link>
				)}
			</div>


			<Popup2 popupName='popup-comment' title={'두벅이 소리함'} comment>
				불편한점, 바라는 점등 다양한 의견을 들려주세요!
			</Popup2>


			{/* First visit: tour of the tiles (measures them, so it lines up on every phone) */}
			<Tutorial />


			{/* S: box-wrap */}
			<div className="box-wrap">
				<div className="box-line">
					<Link to="/Calendar" className="box calendar">
						<p className="v1-keep">{home ? `DAY ${home.day} · 🔥${home.streak}일` : '출석체크'}</p>
						<strong><span>{attendanceCount}</span>일차</strong>
					</Link>
				</div>
				<div className="box-line">
					<Link to="/Study" className="box study">
						<strong>오늘의<br />레슨</strong>
						{home && home.topic && <small>{home.topic}</small>}
					</Link>
					<Link to="/Review" className="box test">
						{home && home.due > 0 && <span className="v1-badge">{home.due}</span>}
						<strong>복습</strong>
						<small>잊기 직전 단어</small>
					</Link>
				</div>
				<div className="box-line">
					<Link to="/Talk" className="box result">
						<strong>회화</strong>
						<small>여행 · 일상 · 문법</small>
					</Link>
				</div>

			</div>
			{/* E: box-wrap */}

		</Layout>
	);


};

export default Main;